import { Box } from "@material-ui/core";
import React, { useContext } from "react";
import { ProcessContext } from "../../../../contexts/ProcessContext";
import { fakeFormsDataIncome } from "../../../../utils/fakeFormsData";
import { useStepHandler } from "../../../../utils/hooks/useStepHandler";
import BackButton from "../../../shared/components/BackButton";
import { STEP_GROUP_IDS } from "../../../shared/config";
import {
  DECLARED_INCOME,
  isSetBankAccountStepAllowedByRole,
} from "../DeclaredIncome/config";
import SetBankAccount from "../shared/steps/SetBankAccount";
import { useSetBankAccountDetails } from "./hooks/useSetBankAccountDetails";

export default function SetBankAccountDetails(props) {
  const {
    state: { participant },
  } = useContext(ProcessContext);

  const { allowInternationalBorrower, alternativePaymentMethod } = props;

  const STEP_GROUP_STEPS_ARRAY = [
    {
      id: DECLARED_INCOME.SET_BANK_ACCOUNT,
      show: () => isSetBankAccountStepAllowedByRole(participant),
    },
  ];
  const CURRENT_STEP_GROUP = STEP_GROUP_IDS.DeclaredIncome;

  const { bankAccountIBAN, onSubmitModule } = useSetBankAccountDetails();

  const currentModuleStepHandler = useStepHandler(
    onSubmitModule,
    fakeFormsDataIncome
  );

  const { manageGroup, submitStep, onBack, backButtonVisible, getStepData } =
    currentModuleStepHandler;

  const stepGroupStepToShow = manageGroup(
    CURRENT_STEP_GROUP,
    STEP_GROUP_STEPS_ARRAY
  );

  return (
    <>
      <Box className="appear-anim" style={{ position: "absolute" }}>
        <BackButton onBack={onBack} show={backButtonVisible} />
      </Box>
      {stepGroupStepToShow === DECLARED_INCOME.SET_BANK_ACCOUNT && (
        <SetBankAccount
          onSubmitForm={submitStep}
          data={getStepData()}
          recordedIBAN={bankAccountIBAN}
          forceCaixaBankIBAN={false}
          allowInternationalBorrower={allowInternationalBorrower}
          alternativePaymentMethod={alternativePaymentMethod}
        />
      )}
    </>
  );
}
